<template>
  <div class="bg-white border border-pale_greem border-b-0 rounded h-full">
    <ul>
      <li v-for="(place, index) in places" v-bind:key="index">
        <div @click="$emit('openPlace', place)" class="p-4 border-b border-section_border flex items-center">
          <img src="@/assets/images/icon-history.svg" alt="" class="mr-2">
          <span class="flex-grow">{{ place.name }}</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  computed: {
    places: function () {
      const a = this.$store.getters['history/getAll']
      return a.reverse()
    }
  }
}
</script>
